<template>
  <v-container align-content-center justify-center>
    <v-layout wrap align-content-center>
      <v-flex lg12>
        <p class="titleColorSystem pb-4 text-center">MARCO NORMATIVO. LEY DE CIENCIA Y TECNOLOGÍA DEL ESTADO DE {{ configuracion.estado.nombre }}.</p>
        <div v-html="texto.html" class="ql-editor">
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  props: ["urlApi","configuracion"],
  data(){
    return{
      texto: {}
    }
  },
  mounted() {
    this.getTexto();
  },
  methods: {
    getTexto(){
      var urlText = process.env.VUE_APP_API_URL + "/api/get-marco-normativo";
      axios.get(urlText).then((response) => {
        this.texto = response.data;
      });
    },
  }
}
</script>
<style>
.text-center{
  text-align: center;
}
</style>